import { computed } from '@vue/composition-api'
import CollectionModule from '@/store/stores/collectionModule/CollectionModule'
import useDynamoDB from '@/store/hook/useDynamoDB'
import CustomAttributeDataDocument from '@/store/stores/collectionModule/documents/customAttribute/CustomAttributeDataDocument'

/**
 * カスタム属性データ: 管理者登録YouTube動画の表示件数設定を操作するための処理
 * @see テーブル設計 https://docs.google.com/spreadsheets/d/1IlMFcrOsJCwWSRz7QF3mckK0WWsvQbeGKPIUPbDVWfo/edit?gid=1208779623#gid=1208779623
 */
export default function useYouTubeDisplayLimitData() {
  // Collection modules
  const youTubeDisplayLimitDataCollectionModule = CollectionModule.createStore(
    CustomAttributeDataDocument,
  )

  const { searchDateRangeData } = useDynamoDB()

  /**
   * カスタム属性データ: 管理者登録YouTube動画の表示件数設定情報を取得する
   */
  const fetchYouTubeDisplayLimitData = async () => {
    const result = await searchDateRangeData({
      tableName: 'custom-attribute-data',
      partitionKey: 'attributeType',
      partitionKeyValue: 'YouTubeDisplayLimit',
      sortKey: 'createdDate',
    })
    youTubeDisplayLimitDataCollectionModule.data = result as Array<CustomAttributeDataDocument>
  }

  /**
   * カスタム属性データ: 管理者登録YouTube動画の表示件数設定情報
   */
  const youTubeDisplayLimitDataList = computed(() => youTubeDisplayLimitDataCollectionModule.data)

  /**
   * カスタム属性データ: targetId毎に分類された管理者登録YouTube動画の表示件数設定情報
   */
  const youTubeDisplayLimitsByTargetId = computed(() =>
    youTubeDisplayLimitDataList.value.reduce((acc, cur) => {
      if (cur.targetId) {
        acc[cur.targetId] = cur
      }
      return acc
    }, Object.create(null) as Record<string, CustomAttributeDataDocument>),
  )

  /**
   * カスタム属性データをクリアする
   */
  const clearYouTubeDisplayLimitData = () => {
    youTubeDisplayLimitDataCollectionModule.clearData()
  }

  return {
    fetchYouTubeDisplayLimitData,
    youTubeDisplayLimitsByTargetId,
    clearYouTubeDisplayLimitData,
  }
}
